import React from 'react'
import PropTypes from 'prop-types'

import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const ItemBrand = ({brand}) => {
    return (
        <Text textTransform="uppercase" fontSize="xs" lineHeight="sm" fontWeight="bold">
            {brand}
        </Text>
    )
}

ItemBrand.propTypes = {
    brand: PropTypes.string
}

export default ItemBrand
